import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { useParams } from "react-router-dom";
import { API_URL } from "..";
import ViewServiceLayer from "../components/ViewServiceLayer";

const ViewServicePage = () => {
    const [data,setData]= useState({})
    const {id} = useParams();
    const fetchAppointments = async () => {
        let headerList = {
          "Accept": "*/*",
          "Content-type": "application/json",
        };
        const response = await fetch(
          API_URL+`/api/service/${id}`,
          { method: "GET", headers: headerList }
        );
        const data = await response.json();
        if (response.status === 200) {
            setData(data)
        }
      };

      useEffect(()=>{
        fetchAppointments()
      },[1])
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="View Service" />
        {
            data.title === undefined ? 
            null:
            <ViewServiceLayer data={data}/>
        }
        
      </MasterLayout>

    </>
  );
};

export default ViewServicePage; 
